/**
 * History-API router for the three client screens.
 *
 * `/terms` and `/privacy` are deliberately *not* routes — they are server-rendered pages, so
 * links to them are plain navigations (they must resolve for Google's OAuth review even with no
 * JavaScript).
 */
export type RouteName = 'landing' | 'consent' | 'menu' | 'play';

const ROUTES: Record<string, RouteName> = {
  '/': 'landing',
  '/consent': 'consent',
  '/menu': 'menu',
  '/play': 'play',
};

export function currentRoute(): RouteName {
  return ROUTES[window.location.pathname] ?? 'landing';
}

export function pathFor(route: RouteName): string {
  return route === 'landing' ? '/' : `/${route}`;
}

let onChange: ((route: RouteName) => void) | null = null;

export function navigate(route: RouteName, replace = false): void {
  const path = pathFor(route);
  if (window.location.pathname !== path) {
    if (replace) window.history.replaceState({}, '', path);
    else window.history.pushState({}, '', path);
  }
  onChange?.(route);
}

export function startRouter(handler: (route: RouteName) => void): void {
  onChange = handler;
  window.addEventListener('popstate', () => handler(currentRoute()));
  handler(currentRoute());
}
